import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Logo } from "../../assets";
import logobhavishya from "../../assets/logo_bhavishya_4.png";

const LargeScreenNavbar = () => {
  const location = useLocation();

  const navLinks = {
    "About Us": "/about",
    "Program": "/programs",
    "Success Stories": "/successstory",
    "Our Presence": "/ourcenters",
    "Products": "/products",
    "Media": "/media",
    "Get in touch": "/contact",
  };

  const handleJoinUsClick = () => {
    if (location.pathname === "/contact") {
      // If already on contact page, scroll to section
      const element = document.getElementById("join-us-section");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      // If not on contact page, navigate to contact page
      window.location.href = "/contact#join-us-section";
    }
  };

  return (
    <nav className="bg-[#EE645A] sticky top-0 z-50 w-full shadow-lg">
      <div className="mx-auto px-4 lg:px-6 xl:px-8 py-2.5 lg:py-3 flex items-center justify-between gap-4">
        
        {/* Logo Section - Fixed sizing */}
        <Link 
          to="/" 
          className="flex items-center shrink-0 group hover:opacity-90 transition-opacity duration-300"
        >
          <img 
            src={Logo} 
            alt="Bhavishya Logo" 
            className="w-10 sm:w-12 lg:w-14 h-10 sm:h-12 lg:h-14 object-contain" 
          />
          <img 
            src={logobhavishya} 
            alt="Bhavishya Text" 
            className="w-16 sm:w-24 lg:w-32 h-auto object-contain" 
          />
        </Link>

        {/* Navigation Links - Hidden on small/medium screens */}
        <div className="hidden xl:flex items-center justify-center gap-6 2xl:gap-8 flex-1">
          {Object.keys(navLinks).map((item) => (
            <Link
              key={item}
              to={navLinks[item]}
              className="text-white font-semibold text-sm 2xl:text-base transition-all duration-300 hover:text-gray-100 hover:scale-105 relative group"
            >
              {item}
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-white transition-all duration-300 group-hover:w-full"></span>
            </Link>
          ))}
        </div>

        {/* Action Buttons */}
        <div className="flex items-center gap-2 sm:gap-3 lg:gap-4 shrink-0">
          <Link
            to="/donate"
            className="bg-black text-white px-3 sm:px-4 lg:px-5 py-2 lg:py-2.5 rounded-lg font-bold text-xs sm:text-sm lg:text-base transition-all duration-300 hover:bg-white hover:text-black hover:shadow-lg transform hover:scale-105"
          >
            Donate Now
          </Link>

          <button
            onClick={handleJoinUsClick}
            className="hidden sm:block bg-black text-white px-3 sm:px-4 lg:px-5 py-2 lg:py-2.5 rounded-lg font-bold text-xs sm:text-sm lg:text-base transition-all duration-300 hover:bg-white hover:text-black hover:shadow-lg transform hover:scale-105 cursor-pointer"
          >
            Join Us
          </button>
        </div>
      </div>
    </nav>
  );
};

export default LargeScreenNavbar;